import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { useAuth } from '../context/AuthContext';
import { useAsyncAction } from '../hooks/useAsyncAction';
import { authStyles } from '../styles/authStyles';

export default function ChangeEmailPage() {
  const { teacher } = useAuth();
  const [newEmail, setNewEmail] = useState('');
  const [sent, setSent] = useState(false);
  const { loading, error, run } = useAsyncAction();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await run(async () => {
      const res = await fetch('/api/teacher/request-email-change', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ new_email: newEmail }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSent(true);
    });
  };

  if (sent) {
    return (
      <DashboardLayout>
        <div style={styles.wrap}>
          <h1 style={styles.heading}>Check your inbox</h1>
          <p style={styles.sub}>
            We sent a confirmation link to <strong>{newEmail}</strong>. Click it to
            complete the email change. The link expires in 24 hours.
          </p>
          <p style={styles.sub}>
            If you don't see it, check your spam folder.
          </p>
          <Link to="/account" style={styles.link}>Back to account settings</Link>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div style={styles.wrap}>
        <h1 style={styles.heading}>Change email address</h1>
        <p style={styles.sub}>
          Your current email is <strong>{teacher?.email}</strong>. Enter the new
          address below and we'll send a confirmation link to it.
        </p>

        {error && <div style={authStyles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={authStyles.form}>
          <label style={authStyles.label}>
            New email address
            <input
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              style={authStyles.input}
              required
              autoFocus
              autoComplete="email"
            />
          </label>
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Sending…' : 'Send confirmation link'}
          </button>
        </form>

        <div style={{ marginTop: '20px' }}>
          <Link to="/account" style={styles.link}>Cancel</Link>
        </div>
      </div>
    </DashboardLayout>
  );
}

// Page-specific overrides/additions on top of ../styles/authStyles
const styles = {
  wrap: { maxWidth: '440px' },
  heading: { ...authStyles.heading, margin: '0 0 8px' },
  sub: { ...authStyles.sub, margin: '0 0 20px', lineHeight: '1.6' },
  button: { ...authStyles.button, marginTop: undefined },
  link: { ...authStyles.link, fontSize: '14px' },
};
